import { html, type Html, Page, rune } from 'rune-ts';
import klass from './CreatorViewDetail.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';
import { main_detail } from '../../../../../modules/MShop/App/Today/S/Tmpl/main_detail';
import { MShopUtilF } from '../../../../../modules/MShop/Util/F/Function/module/MShopUtilF';
import { Header } from '../../components/cells/Header/Global/Header.ts';
import { $delegate, $qs } from 'fxdom/es';
import { listenDocumentEvent } from '../../../shared/util/event';
import { go } from 'fxjs/es';
import Swiper from 'swiper';
import UAParser from 'ua-parser-js';
import {
  CreatorViewDetail,
  CreatorViewListItemData,
  NearCreatorViewItem,
} from '../../../features/CreatorView/type';
import { hydrateFeed } from '../CurationDetail/util';
import { BaseLayoutOptions } from '../../../features/Core/service';
import header_klass from '../../components/cells/Header/Global/Header.module.scss';
import sanitizer from 'sanitizer';
import { font } from '@services/MarppleShop/shared/typography';
import { CardProductControllerView } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/CardProductControllerView.ts';
import { classes } from '@services/MarppleShop/shared/util';
import { IconsBasicEnquadArrowChevronRightIcon } from '@services/MarppleShop/shared/components/atoms/Icon';
import { map, pipe, reject, take, toArray } from '@fxts/core';
import { CardCreatorViewView } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardCreatorview/CardCreatorViewView.ts';
import {
  makeEmptyScreenNavigate,
  makePopupScreenNavigate,
} from '@services/MarppleShop/shared/app/navigate.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';
import { ButtonView } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/Buttons/ButtonView.ts';

const LATEST_CREATOR_VIEW_LIMIT = 4;

export type CreatorViewDetailPageData = {
  related_creator_views: CreatorViewListItemData[];
  creator_view: CreatorViewDetail;
  next_creator_view: NearCreatorViewItem | undefined;
  prev_creator_view: NearCreatorViewItem | undefined;
  layout_options: BaseLayoutOptions;
};

export class CreatorViewDetailPage extends Page<CreatorViewDetailPageData> {
  override onMount() {
    super.onMount();
    const {
      layout_options: { is_mobile },
    } = this.data;
    const header_el = document.querySelector('.Header') as HTMLElement;
    const header_view = rune.getView(header_el, Header) as Header;

    // 헤드룸 offset 커스텀
    const padding_top_of_today_body = parseInt(window.getComputedStyle($qs('.today-body'))?.marginTop || '0');

    const header_element = header_view.element().querySelector(`.${header_klass.header}`) as HTMLDivElement;
    Header.initHeadroom(header_element, {
      ...header_view.state.headroom,
      use: true,
      offset: {
        up: padding_top_of_today_body,
        down: padding_top_of_today_body,
      },
    });

    // 아래쪽 관련 아이템 스와이퍼 적용
    if (is_mobile) {
      new Swiper('.today-relates__items', {
        loop: false,
        slidesPerView: 'auto',
        allowTouchMove: true,
      });
    }

    const left_sidebar_el = $qs('.today-body__left_sidebar') as HTMLDivElement;

    listenDocumentEvent('header_pinned', () => {
      left_sidebar_el.classList.remove('unpinned');
    });
    listenDocumentEvent('header_unpinned', () => {
      left_sidebar_el.classList.add('unpinned');
    });
    listenDocumentEvent('header_top', () => {
      left_sidebar_el.classList.add('top');
    });
    listenDocumentEvent('header_nottop', () => {
      left_sidebar_el.classList.remove('top');
    });

    go(
      this.element(),
      $delegate('click', '.share-btn', (e) => {
        const is_app = MShopUtilF.isApp();
        const title = e.currentTarget.dataset.title;
        const ua = new UAParser();
        const app_version = (/MarppleShopApp@(\w+.\w+.\w+)/gm.exec(ua.getUA()) || [])[1];

        if (is_app && app_version && app_version >= '1.1.0') {
          return MShopUtilF.postMessage({
            share: {
              title: `${T('마플샵')} - ${title}`,
              url: location.href,
            },
          });
        }

        try {
          navigator.clipboard
            .writeText(location.href)
            .then(() => {
              MShopUtilF.popToastMsg(T('s_about::url_copied2'), 'info');
            })
            .catch(() => {
              MShopUtilF.popToastMsg(T('s_about::url_failed'), 'info');
            });
        } catch (e) {
          MShopUtilF.clipboard(location.href);
          MShopUtilF.popToastMsg(T('s_about::url_copied2'), 'info');
        }
      }),
      $delegate('click', 'a', (e) => {
        if (!e.currentTarget.href.includes('/@/todays/') || !MShopUtilF.isApp()) return;
        e.originalEvent.preventDefault();
        location.replace(e.currentTarget.href);
      }),
    );

    hydrateFeed(this.element());
  }

  protected override template(): Html {
    const { related_creator_views, creator_view, next_creator_view, prev_creator_view, layout_options } =
      this.data;

    const { is_mobile } = layout_options;

    return html`
      <div class="${klass.page}">
        ${new LayoutView(
          {
            body: html`<div class="${klass.body}">
              ${html.preventEscape(
                main_detail({
                  is_mobile,
                  today: creator_view,
                  next_today: next_creator_view,
                  prev_today: prev_creator_view,
                  is_sharable: !is_mobile,

                  steps: null,
                  feed_category_id: null,
                  products_html: null,
                  related_section_title: null,
                  related_todays_html: null,
                  show_related_see_more: null,
                }),
              )}

              <div class="${klass.creator_view_products}">
                <span class="${font('24_bold', '18_semibold')}">${ET('creator_view::related_products')}</span>

                <div class="${klass.product_list}">
                  ${creator_view.products.map(
                    (product) =>
                      new CardProductControllerView({
                        card_product_view_props: {
                          type: 'A',
                          size: is_mobile ? 'Xsmall' : 'Large',
                          layout: 'Vertical',
                          theme: 'Light',
                        },
                        product_card_view_data: product,
                        options: {
                          resize_width: 126 * 2,
                          is_lazy: true,
                        },
                      }),
                  )}
                </div>
              </div>

              <div class="${klass.creator_view_latest}">
                <div class="${klass.section}">
                  <span class="${classes(klass.section_title, font('24_bold', '18_semibold'))}"
                    >${ET('creator_view::latest_creator_view')}</span
                  >

                  ${is_mobile
                    ? null
                    : html`<a class="${klass.section_control}" href="${`/${ET.lang}/@/creator_views`}">
                        <span class="${classes(klass.section_control_text, font('14_medium'))}">
                          ${ET('creator_view::see_more')}</span
                        >

                        <span class="${klass.icons_basic_enquad}"
                          >${IconsBasicEnquadArrowChevronRightIcon}</span
                        >
                      </a>`}
                </div>

                <ul class="${klass.list}">
                  ${pipe(
                    related_creator_views,
                    reject((creatorView) => creatorView.id === creator_view.id),
                    take(LATEST_CREATOR_VIEW_LIMIT),
                    map(
                      (creatorView) =>
                        html`<li class="${klass.item}">
                          <article>
                            <a
                              href="${`/${ET.lang}/@/creator_views/${creatorView.id}`}"
                              data-post-message="${pipe(
                                `/${ET.lang}/@/creator_views/${creatorView.id}`,
                                makeEmptyScreenNavigate,
                                dataStr,
                              )}"
                            >
                              ${new CardCreatorViewView({
                                device: 'PC',
                                layout: 'Detail',
                                ...creatorView,
                              })}
                            </a>
                          </article>
                        </li>`,
                    ),
                    toArray,
                  )}
                </ul>

                ${is_mobile
                  ? html`<div class="${klass.button_container}">
                      ${new ButtonView({
                        size: 40,
                        color: 'Custom-A',
                        label: ET('curation::curation_detail_page::button_text'),
                        as: 'a',
                        href: `/${ET.lang}/@/creator_views`,
                        dataset: {
                          postMessage: pipe(`/${ET.lang}/@/creator_views`, makePopupScreenNavigate, dataStr),
                        },
                      })}
                    </div>`
                  : null}
              </div>
            </div>`,
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            full_width: is_mobile,
            floating_box: {
              share: is_mobile
                ? {
                    title: sanitizer.unescapeEntities(creator_view.title),
                    description: ET('mps2::share::creator_view_description', {
                      creator_name: creator_view.creator_name,
                    }),
                  }
                : undefined,
            },
            ...layout_options,
          },
        )}
      </div>
    `;
  }
}
